import React,{useEffect,useState} from 'react';
import { Link } from 'react-router-dom';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';



// import required modules
import { EffectFade, Navigation, Pagination,Autoplay } from 'swiper/modules';

export default function DevotionalSwiper({homeSliderData,homeSliderDataError}) { 

                const ssrHomeSliderData= homeSliderData ? homeSliderData : null
                const [error,setError]= useState(homeSliderDataError)
                const [data,setData]=useState(ssrHomeSliderData)   
                const [loading,setLoading]=useState(!data && !error)
             
               
            

  useEffect(() => {

    if (ssrHomeSliderData ) {
    
        
         setError(null)
         setLoading(false)
         return;
    }

    else {
  
      const getData = async () => {
           setLoading(true)
           try {
  
            let response=await fetch(`https://www.teluguone.com/devotional_api/devotionalHomeSliderJson`)
            if (!response.ok) throw new Error('Network response was not ok');
  
            let data=await response.json()
            
           
               
                 setData(data.home_slider)
                 setLoading(false)
                 setError(null)
          
  
            
           } catch (error) {
              
             
                  setData([])
                  setLoading(false)
                  setError(error.message)
            
                console.log(error.message)
           }
      }
   
      getData()

    }


  }, [])




  if (loading)  {
       
    return (
      <div className='devotional-swiper'>
      <Swiper
        spaceBetween={30}
        effect={'fade'}
        navigation={true}
        pagination={{ clickable: true }}
        loop={true}
        autoplay={{ delay: 3000 }}  
        modules={[EffectFade, Navigation, Pagination, Autoplay]}
        className="mySwiper"
     >
  
  
                  <SwiperSlide   >
                  <Link to="">
                   <img alt="slider-image" src='/devotional/assets/images/error_img.webp' />
                   </Link>
               </SwiperSlide>
            </Swiper>
     </div>
  )
      
  
  }
  
  
     if (error) {
  
        return (
          <div className='devotionl-swiper'>
          <div className="json-loading-error-div">
           <img  src="/devotional/assets/images/json_error.png" alt="json_error" />
           </div>
          </div>
        )
     }
  



  return (
    <div className='devotional-swiper'>
      <Swiper
       spaceBetween={30}
        effect={'fade'}
        navigation={true}
        pagination={{ clickable: true }}
        loop={true}
        autoplay={{ delay: 3000 }}  
        modules={[EffectFade, Navigation, Pagination, Autoplay]}
        className="mySwiper"
      > 

        {Array.isArray(data) && data.map((item,index) =>     
               <SwiperSlide key={index}  >
                  <Link 
                   target={(item.banner_link && item.banner_link.includes('/devotional')) ? '_self' : '_blank'}
                   rel='noreferrer'
                  to={(item.banner_link && item.banner_link.includes('/devotional')) ? item.banner_link.substring(item.banner_link.indexOf('/devotional')+11) : item.banner_link}>
                   <img loading={index === 0 ? 'eager' : 'lazy'}  fetchpriority={index === 0 ? 'high' : 'auto'}  alt="slider-image" src={item.banner_img ? item.banner_img : '/devotional/assets/images/error_img.webp'} />
                   </Link>
               </SwiperSlide>
              ) }


      </Swiper>
    </div>
  );
}
